import { render, staticRenderFns } from "./ocrRecordSet.vue?vue&type=template&id=5a987490&scoped=true&"
import script from "./ocrRecordSet.vue?vue&type=script&lang=js&"
export * from "./ocrRecordSet.vue?vue&type=script&lang=js&"
import style0 from "./ocrRecordSet.vue?vue&type=style&index=0&id=5a987490&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a987490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a987490')) {
      api.createRecord('5a987490', component.options)
    } else {
      api.reload('5a987490', component.options)
    }
    module.hot.accept("./ocrRecordSet.vue?vue&type=template&id=5a987490&scoped=true&", function () {
      api.rerender('5a987490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/ocrRecordSet.vue"
export default component.exports